import axios from "axios";
import { userApiBaseUrl, workflowApiBaseUrl } from "./Index";
import { parentServiceUrl } from "../utils/ServicesUrls";

// =========================
// Create Axios Instances
// =========================
export const api = axios.create({
  baseURL: userApiBaseUrl,
  withCredentials: true,
});

export const workflowApiUrl = axios.create({
  baseURL: workflowApiBaseUrl,
  withCredentials: false,
});

export const userApiUrl = axios.create({
  baseURL: userApiBaseUrl,
  withCredentials: false,
});

// =========================
// Attach Interceptor to All
// =========================
const attachInterceptor = (instance: typeof api) => {
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        console.warn(
          "Access token expired. Requesting new token from parent..."
        );
        window.parent.postMessage("UNAUTHORIZED", parentServiceUrl);
      }
      return Promise.reject(error);
    }
  );
};

// Apply interceptor to all instances
[api, workflowApiUrl, userApiUrl].forEach(attachInterceptor);

// =========================
// Helper to Set Auth Header
// =========================
export const setAuthHeader = (token: string | null) => {
  if (token) {
    const headerValue = `Bearer ${token}`;
    api.defaults.headers.common["Authorization"] = headerValue;
    workflowApiUrl.defaults.headers.common["Authorization"] = headerValue;
    userApiUrl.defaults.headers.common["Authorization"] = headerValue;
  } else {
    delete api.defaults.headers.common["Authorization"];
    delete workflowApiUrl.defaults.headers.common["Authorization"];
    delete userApiUrl.defaults.headers.common["Authorization"];
  }
};
